// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__31fo1","actions":"GroupTable_actions__KgzTM","deleteModalFooter":"GroupTable_deleteModalFooter__2jiaY"};